import { Button } from '@yellowcard/components-library-vue3';
import { defineComponent, ref } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { logoutUser } from '@/utils/logout';
import useTransactionsStore from '@/store/modules/transactions';
import router, { RoutePaths } from '@/router';
import { TransactTypes } from '@/types/transact';
var TransactSteps = TransactTypes.TransactSteps;
export default defineComponent({
    name: 'IdDuplication',
    props: {},
    components: {
        Button,
    },
    setup() {
        const kycStore = useKycStore();
        const transactionsStore = useTransactionsStore();
        const { maskedEmail } = storeToRefs(kycStore);
        const { currentStep: transactStep } = storeToRefs(transactionsStore);
        const isButtonDisabled = ref(false);
        const authStore = useAuthStore();
        const loginWithDifferentAccount = async () => {
            // Reset current session and redirect to auth
            isButtonDisabled.value = true;
            await authStore.Logout();
            logoutUser();
            transactStep.value = TransactSteps.BUY_1;
            await router.push(RoutePaths.Transact);
            // Could redirect to auth or handle differently based on your app flow
        };
        return {
            maskedEmail,
            loginWithDifferentAccount,
            isButtonDisabled,
        };
    },
});
